export enum GlobalMyAccountFavoritesRoutes {
  BASE = 'myaccount-favorites',
  MY_FAVORITES = 'my-favorites',
  COMPANY_LIST = 'my-companylists',
  LEGACY_COMPANY_LISTS = 'myaccount-companylists',
  RECOMMENDED_PRODUCTS = 'recommendation-list',
  RECENTLY_PURCHASED = 'last-purchases',
  SUBMITTALS = 'myaccount-submittals'
}
